/* eslint-disable no-prototype-builtins */
/* eslint-disable no-confusing-arrow */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable prefer-object-spread */
/* eslint-disable func-call-spacing */
/* eslint-disable no-spaced-func */
import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
  lazy,
  Suspense,
} from 'react';

import { useSelector, useDispatch } from 'react-redux';

// Material
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

// React Swipeable Views
import SwipeableViews from 'react-swipeable-views';

// React CSV
import { CSVLink } from 'react-csv';

// Helpers
import { formatDateAndTime } from 'helpers/date';

// Material Theme
import { useTheme } from '@material-ui/core/styles';

// Helpers

// Actions
import * as CompaniesActions from 'store/ducks/companies/actions';
import * as ReportActions from 'store/ducks/reports/actions';
import { setOpen, setClose } from 'store/ducks/dialogs/actions';

// Types
import { ApplicationState } from 'store';
import {
  SelectedReportTypesInterface,
  CompanyReportInterface,
} from 'store/ducks/companies/types';

// Constants
import CONST_TRANSPORT_VOUCHER_COLLECTION from 'constants/transportVoucherCollectionReport';
import CONST_DATE_TYPE from 'constants/dateType';
import IMAGES from 'constants/images';
import { REPORTS_TYPES } from 'constants/report';
import ITEMS from 'constants/itemsByFilter';
import TITLES_OPTIONS from 'constants/infoModulesTitle';

// Components
import { TabPanel } from 'components/TabPanel';
import { CustomTabs } from 'components/ReportComponents';
import { TablePlaceholder } from 'components/TablePlaceholder';
import {
  MainContent,
  DialogueExport,
  SearchComponent,
  XlsHeaderInterface,
  XlsRowInterface,
  ReportTitle,
} from 'components';
import { TransactionNavigation } from './components/TransactionNavigation';
import { TaxesNavigation } from './components/TaxesNavigation';
import { GroupingsModal } from './components/GroupingsModal';
import { Submissions, History } from '../../../../components';

// Styles
import useStyles from './TransportVoucherCollectionReportDatails.styles';

// Lazy Components
const Filter = lazy(() => import('components/Filter'));
const TotalCountComponent = lazy(() =>
  import('components/TotalCountComponent'),
);

interface StateProps {
  setSubmissionData: (param: any) => void;
  setIsAddSubmissiion: (param: any) => void;
  setIsEditSubmissiion: (param: any) => void;
}

type Props = StateProps;

const TransportVoucherCollectionReportDatails: React.FC<Props> = ({
  setSubmissionData,
  setIsAddSubmissiion,
  setIsEditSubmissiion,
}) => {
  const theme = useTheme();
  const classes = useStyles();
  const dispatch = useDispatch();
  const csvRef = useRef(null);

  const [tableCSV, setTableCSV] = useState('');
  const [reportIsVisible, setReportIsVisible] = useState(false);
  const [currNavGuide, setCurrNavGuide] = useState(0);
  const [tableReference, setTableReference] = useState();
  const [groupingsDialog, setGroupingsDialog] = useState(false);
  const [generalNavGuide, setGeneralNavGuide] = useState(0);
  const [headerTaxes, setHeaderTaxes] = useState<any>([]);
  const [xlsHeader, setXlsHeader] = useState<XlsHeaderInterface[]>();
  const [xlsRows, setXlsRows] = useState<Array<XlsRowInterface[]>>([]);

  const [transactionslist, setTransactionsList] = useState<
    CompanyReportInterface[]
  >();
  const [transactionGroupings, setTransactionGroupings] = useState<string[]>(
    [],
  );

  const transactionOptions = useMemo(
    () => [
      {
        key: 'usedDate',
        value: 'Data',
      },
      {
        key: 'status',
        value: 'Status',
      },
      {
        key: 'paymentType',
        value: 'Método de Pagamento',
      },
    ],
    [],
  );

  const [periodString, setPeriodString] = useState('');

  const [simplePdfData, setSimplePdfData] = useState<{
    title: string;
    subtitle: string;
    filters: string;
    headers: any;
    rows: any;
  }>({
    title: '',
    subtitle: '',
    filters: '',
    headers: [],
    rows: [],
  });

  const initialCompanyReportList = useSelector(
    (state: ApplicationState) => state.companies.companyReportList,
  );

  const startDate = useSelector(
    (state: ApplicationState) => state.reports.selectedStartDate,
  );

  const endDate = useSelector(
    (state: ApplicationState) => state.reports.selectedEndDate,
  );

  const transportOperatorSelected = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorSelected,
  );
  const transportOperatorsList = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorsList,
  );

  const handleLoadData = useCallback(async () => {
    setReportIsVisible(true);

    dispatch(
      CompaniesActions.reportCompanyRequest({
        startDate: new Date().setHours(0, 0, 0),
        endDate: new Date().setHours(23, 59, 59),
        _includes: 'payment,history,order,tax',
        reportType: REPORTS_TYPES.CHARGE_GENERAL,
      }),
    );

    const tempPeriodString = `Dia: ${new Date().toLocaleDateString('pt-BR', {
      dateStyle: 'short',
    })}`;

    setPeriodString(tempPeriodString);
  }, []);

  const totalPix = (() =>
    initialCompanyReportList
      .filter(
        (report: any) =>
          report.paymentMethod === CONST_TRANSPORT_VOUCHER_COLLECTION.PIX,
      )
      .reduce((acc: any, cur: any) => {
        if (transactionGroupings.length > 0) {
          return acc + cur?.totalValue!;
        }
        return acc + cur.value;
      }, 0))();

  const totalCreditCard = (() =>
    initialCompanyReportList
      .filter(
        (report: any) =>
          report.paymentMethod ===
            CONST_TRANSPORT_VOUCHER_COLLECTION.CREDIT_CARD ||
          report.paymentMethod ===
            CONST_TRANSPORT_VOUCHER_COLLECTION.CREDIT_CARD_CLEAN ||
          report.paymentMethod ===
            CONST_TRANSPORT_VOUCHER_COLLECTION.PINPAD_CREDIT_CARD,
      )
      .reduce((acc: any, cur: any) => {
        if (transactionGroupings.length > 0) {
          return acc + cur?.totalValue!;
        }
        return acc + cur.value;
      }, 0))();
  const totalDebitCard = (() =>
    initialCompanyReportList
      .filter(
        (report: any) =>
          report.paymentMethod ===
            CONST_TRANSPORT_VOUCHER_COLLECTION.DEBIT_CARD ||
          report.paymentMethod ===
            CONST_TRANSPORT_VOUCHER_COLLECTION.PINPAD_DEBIT_CARD,
      )
      .reduce((acc: any, cur: any) => {
        if (transactionGroupings.length > 0) {
          return acc + cur?.totalValue!;
        }
        return acc + cur.value;
      }, 0))();

  const totalBoleto = (() =>
    initialCompanyReportList
      .filter(
        (report: any) =>
          report.paymentMethod === CONST_TRANSPORT_VOUCHER_COLLECTION.BOLETO,
      )
      .reduce((acc: any, cur: any) => {
        if (transactionGroupings.length > 0) {
          return acc + cur?.totalValue!;
        }
        return acc + cur.value;
      }, 0))();

  const totalMoney = (() =>
    initialCompanyReportList
      .filter(
        (report: any) =>
          report.paymentMethod === CONST_TRANSPORT_VOUCHER_COLLECTION.MONEY,
      )
      .reduce((acc: any, cur: any) => {
        if (transactionGroupings.length > 0) {
          return acc + cur?.totalValue!;
        }
        return acc + cur.value;
      }, 0))();

  const totalVoucher = (() =>
    initialCompanyReportList
      .filter(
        (report: any) =>
          report.paymentMethod === CONST_TRANSPORT_VOUCHER_COLLECTION.VOUCHER,
      )
      .reduce((acc: any, cur: any) => {
        if (transactionGroupings.length > 0) {
          return acc + cur?.totalValue!;
        }
        return acc + cur.value;
      }, 0))();
  const totalRequisition = (() =>
    initialCompanyReportList
      .filter(
        (report: any) =>
          report.paymentMethod ===
          CONST_TRANSPORT_VOUCHER_COLLECTION.REQUISITION,
      )
      .reduce((acc: any, cur: any) => {
        if (transactionGroupings.length > 0) {
          return acc + cur?.totalValue!;
        }
        return acc + cur.value;
      }, 0))();
  const totalFree = (() =>
    initialCompanyReportList
      .filter(
        (report: any) =>
          report.paymentMethod === CONST_TRANSPORT_VOUCHER_COLLECTION.FREE,
      )
      .reduce((acc: any, cur: any) => {
        if (transactionGroupings.length > 0) {
          return acc + cur?.totalValue!;
        }
        return acc + cur.value;
      }, 0))();
  const totalPosPaid = (() =>
    initialCompanyReportList
      .filter(
        (report: any) =>
          report.paymentMethod === CONST_TRANSPORT_VOUCHER_COLLECTION.POS_PAID,
      )
      .reduce((acc: any, cur: any) => {
        if (transactionGroupings.length > 0) {
          return acc + cur?.totalValue!;
        }
        return acc + cur.value;
      }, 0))();
  const totalExternal = (() =>
    initialCompanyReportList
      .filter(
        (report: any) =>
          report.paymentMethod === CONST_TRANSPORT_VOUCHER_COLLECTION.EXTERNAL,
      )
      .reduce((acc: any, cur: any) => {
        if (transactionGroupings.length > 0) {
          return acc + cur?.totalValue!;
        }
        return acc + cur.value;
      }, 0))();

  // status totalizers
  const totalError = (() =>
    initialCompanyReportList
      .filter(
        (report: any) =>
          report.status === CONST_TRANSPORT_VOUCHER_COLLECTION.ERROR,
      )
      .reduce((acc: any, cur: any) => {
        if (transactionGroupings.length > 0) {
          return acc + cur?.totalValue!;
        }
        return acc + cur.value;
      }, 0))();

  const totalPaid = (() => {
    const COMPLETED_KEY = CONST_TRANSPORT_VOUCHER_COLLECTION.STATUS[2].KEY;
    return initialCompanyReportList
      .filter((report: any) => report.status === COMPLETED_KEY)
      .reduce((acc: any, cur: any) => {
        if (transactionGroupings.length > 0) {
          return acc + cur?.totalValue!;
        }
        return acc + cur.value;
      }, 0);
  })();

  const total = (() =>
    initialCompanyReportList.reduce((acc: any, cur: any) => {
      if (transactionGroupings.length > 0) {
        return acc + cur?.totalValue!;
      }
      return acc + cur.value;
    }, 0))();

  const totalPaidWithDates = (() =>
    initialCompanyReportList.reduce(
      (acc: any, cur: any) => acc + cur?.totalValue!,
      0,
    ))();

  const totalCollected = (() => {
    const CANCELED_OR_ERROR_KEY =
      CONST_TRANSPORT_VOUCHER_COLLECTION.STATUS[1].KEY;
    return initialCompanyReportList
      .filter((report: any) => report.status === CANCELED_OR_ERROR_KEY)
      .reduce((acc: any, cur: any) => {
        if (transactionGroupings.length > 0) {
          return acc + cur?.totalValue!;
        }
        return acc + cur.value;
      }, 0);
  })();

  const totalOthers = (() => {
    const CANCELED_OR_CREATED_KEY =
      CONST_TRANSPORT_VOUCHER_COLLECTION.STATUS[0]?.KEY;
    const EXPIRED_KEY = CONST_TRANSPORT_VOUCHER_COLLECTION.STATUS[4]?.KEY;
    const CANCELED_KEY = CONST_TRANSPORT_VOUCHER_COLLECTION.STATUS[5]?.KEY;
    return initialCompanyReportList
      .filter(
        (report: any) =>
          report.status === CANCELED_OR_CREATED_KEY ||
          report.status === EXPIRED_KEY ||
          report.status === CANCELED_KEY,
      )
      .reduce((acc: any, cur: any) => {
        if (transactionGroupings.length > 0) {
          return acc + cur?.totalValue!;
        }
        return acc + cur.value;
      }, 0);
  })();

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setGeneralNavGuide(newValue);
  };

  const updatePaymentReport = useCallback(
    async (
      groups: string[],
      customStartDate?: number,
      customEndDate?: number,
      selectedPaymentType?: any,
      selectedCompanyStatus?: any,
      selectedDateType?: any,
      selectedCompanyType?: any,
    ) => {
      dispatch(
        CompaniesActions.reportCompanyRequest(
          Object.assign(
            {},
            {
              startDate: customStartDate ?? startDate.getTime(),
              endDate: customEndDate ?? endDate.getTime(),
              paymentType:
                selectedPaymentType?.length > 0
                  ? selectedPaymentType
                      .map((type: SelectedReportTypesInterface) => type.KEY)
                      .join()
                  : undefined,
              status:
                selectedCompanyStatus !== ''
                  ? CONST_TRANSPORT_VOUCHER_COLLECTION.STATUS.find(
                      (s) => s.KEY === selectedCompanyStatus,
                    )?.KEY
                  : undefined,
              dateType:
                selectedDateType !== ''
                  ? Object.values(CONST_DATE_TYPE.TYPE).find(
                      (s) => s.KEY === selectedDateType,
                    )?.KEY
                  : undefined,
              type:
                selectedCompanyType?.length > 0
                  ? selectedCompanyType
                      .map((type: SelectedReportTypesInterface) => type.KEY)
                      .join()
                  : undefined,
              _group: groups.join(),
              reportType: REPORTS_TYPES.CHARGE_GENERAL,
            },
            groups.length === 0 && { _includes: 'payment,history,order,tax' },
          ),
        ),
      );
    },
    [dispatch, startDate, endDate],
  );

  const handleApply = (data: any) => {
    dispatch(setClose({}));
    setReportIsVisible(true);

    const {
      startedAt,
      startDate,
      endDate,
      selectedCompanyType,
      selectedCompanyStatus,
      selectedPaymentType,
      selectedDateType,
    } = data;

    // const filters: ChipsInterface[] = [];
    const isPeriod = startDate?.getTime() < endDate?.getTime();
    let startDateValue;
    let endDateValue;
    if (isPeriod) {
      startDateValue = new Date(data?.startDate).getTime();
      endDateValue = new Date(data?.endDate).getTime();
    } else if (startedAt) {
      startDateValue = new Date(data?.startedAt).setHours(0, 0, 0);
      endDateValue = new Date(data?.startedAt).setHours(23, 59, 59);
    }

    if (transactionGroupings.length) {
      if (isPeriod) {
        dispatch(
          ReportActions.setSelectedStartDate({
            selectedStartDate: startDate,
          }),
        );
        dispatch(
          ReportActions.setSelectedEndDate({
            selectedEndDate: endDate,
          }),
        );
      }

      updatePaymentReport(
        transactionGroupings,
        startDateValue,
        endDateValue,
        selectedPaymentType,
        selectedCompanyStatus,
        selectedDateType,
        selectedCompanyType,
      );
    } else {
      if (isPeriod) {
        dispatch(
          ReportActions.setSelectedStartDate({
            selectedStartDate: startDate,
          }),
        );
        dispatch(
          ReportActions.setSelectedEndDate({
            selectedEndDate: endDate,
          }),
        );
      }
      dispatch(
        CompaniesActions.reportCompanyRequest({
          startDate: startDateValue,
          endDate: endDateValue,
          type:
            selectedCompanyType?.length > 0
              ? selectedCompanyType
                  .map((type: SelectedReportTypesInterface) => type.KEY)
                  .join()
              : undefined,
          status:
            selectedCompanyStatus !== ''
              ? CONST_TRANSPORT_VOUCHER_COLLECTION.STATUS.find(
                  (s) => s.KEY === selectedCompanyStatus,
                )?.KEY
              : undefined,
          paymentType:
            selectedPaymentType?.length > 0
              ? selectedPaymentType
                  .map((type: SelectedReportTypesInterface) => type.KEY)
                  .join()
              : undefined,
          dateType:
            selectedDateType !== ''
              ? Object.values(CONST_DATE_TYPE.TYPE).find(
                  (s) => s.KEY === selectedDateType,
                )?.KEY
              : undefined,
          _includes: 'payment,history,order,tax',
          reportType: REPORTS_TYPES.CHARGE_GENERAL,
        }),
      );
    }

    const tempPeriodString = `De: ${
      isPeriod
        ? formatDateAndTime(new Date(startDate))
        : formatDateAndTime(new Date(startedAt))
    } até: ${
      isPeriod
        ? formatDateAndTime(new Date(endDate))
        : formatDateAndTime(new Date(startedAt))
    }`;

    let updatedPeriodString = tempPeriodString;

    if (selectedCompanyType?.length > 0) {
      const tempLinesString = `Tipo: ${selectedCompanyType
        .map((e: any) => e.VALUE)
        .join(', ')}`;
      updatedPeriodString += ', ' + tempLinesString;
    }

    if (selectedPaymentType?.length > 0) {
      const tempLinesString = `Tipo de Pagamento: ${selectedPaymentType
        .map((e: any) => e.VALUE)
        .join(', ')}`;
      updatedPeriodString += ', ' + tempLinesString;
    }

    if (selectedCompanyStatus !== '') {
      const tempLinesString = `Status: ${
        Object.values(CONST_DATE_TYPE.TYPE).find(
          (s) => s.KEY === selectedDateType,
        )?.KEY
      }`;
      updatedPeriodString += ', ' + tempLinesString;
    }

    setPeriodString(updatedPeriodString);
  };

  const handleTransactionGrouping = useCallback(
    (groups: Array<string>) => {
      setTransactionGroupings(groups);
      updatePaymentReport(groups);
      setGroupingsDialog(false);
    },
    [updatePaymentReport],
  );

  // Formatters
  const formatDateTime = useMemo(
    () => (date: Date) => date && new Date(date).toLocaleString('pt-BR'),
    [],
  );

  // const formatDate = useMemo(() => (date: string) => date && format(date), []);

  const formatTransactionId = useMemo(
    () => (id: string) => (id && id.split('-')[0]) || '',
    [],
  );

  const formatValue = useMemo(
    () => (value: number) =>
      value &&
      `R$${value.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      })}`,
    [],
  );

  const formatTax = useMemo(
    () => (tax: number) => (tax > 0 ? `${tax} %` : '---'),
    [],
  );

  const formatNSU = useMemo(() => (nsu: string) => nsu || '---', []);

  const formatStaus = useMemo(
    () => (status: number) =>
      CONST_TRANSPORT_VOUCHER_COLLECTION.STATUS.find(
        ({ KEY }) => KEY === status,
      )?.VALUE || '---',
    [],
  );

  const formatPaymentMethod = useMemo(
    () => (paymentMethod: string) =>
      CONST_TRANSPORT_VOUCHER_COLLECTION.PAYMENT_TYPE.find(
        ({ KEY }) => KEY === paymentMethod,
      )?.VALUE || '---',
    [],
  );

  // Field to Formatter Mapping
  const fieldFormatting = new Map<string, (arg: any) => any>([
    ['createdAt', formatDateTime],
    // ['usedDate', formatDate],
    ['id', formatTransactionId],
    ['tax', formatTax],
    ['value', formatValue],
    ['nsu', formatNSU],
    ['totalValue', formatValue],
    ['status', formatStaus],
    ['paymentMethod', formatPaymentMethod],
    ['paymentType', formatPaymentMethod],
  ]);

  const TOTAL_VALUE = { key: 'totalValue', name: 'Valor total' };
  const COUNT = { key: 'count', name: 'Quantidade' };

  const COLUMN_DEFINITIONS = {
    base: [
      { key: 'id', name: 'ID Transação' },
      { key: 'name', name: 'Nome' },
      { key: 'createdAt', name: 'Data e Hora' },
      { key: 'document', name: 'Documento' },
      { key: 'paymentMethod', name: 'Método de Pagamento' },
      { key: 'value', name: 'Valor Pedido' },
      { key: 'tax', name: 'Imposto' },
      { key: 'orderValue', name: 'Valor Pago' },
      { key: 'status', name: 'Status' },
    ],

    groupings: {
      usedDate: { key: 'usedDate', name: 'Data' },
      status: { key: 'status', name: 'Status' },
      paymentType: { key: 'paymentType', name: 'Método de Pagamento' },
    },

    common: [TOTAL_VALUE, COUNT],
  };

  const getGroupedColumns = () => {
    if (transactionGroupings.length === 0) {
      return COLUMN_DEFINITIONS.base;
    }

    const selectedColumns = transactionGroupings.map((grouping) => {
      const groupingKey = grouping === 'paymentType' ? 'paymentType' : grouping;
      return COLUMN_DEFINITIONS.groupings[
        groupingKey as keyof typeof COLUMN_DEFINITIONS.groupings
      ];
    });

    return [...selectedColumns, ...COLUMN_DEFINITIONS.common];
  };

  useEffect(() => {
    if (initialCompanyReportList.length > 0) {
      const tempTaxes = initialCompanyReportList
        ?.flatMap((company: any) => {
          const taxNames = company?.Taxes?.map((tax: any) => tax?.name);
          return taxNames;
        })
        .filter((item: any): item is string => typeof item === 'string');

      const uniqueTaxes = tempTaxes.reduce((acc: any, tax: any) => {
        if (!acc.includes(tax as never)) {
          acc.push(tax as never);
        }
        return acc;
      }, []);

      setHeaderTaxes(uniqueTaxes);
    }
  }, [initialCompanyReportList]);

  useEffect(() => {
    setTransactionsList(initialCompanyReportList);
  }, [initialCompanyReportList]);

  useEffect(() => {
    if (currNavGuide === 0) {
      const headerSimplePdf =
        transactionGroupings.length === 0
          ? [
              'ID Transação',
              'Nome',
              'Data e Hora',
              'Dcoumento',
              'Método de Pagamento',
              'Valor Pedido',
              'Imposto',
              'Valor Pago',
              'Status',
            ]
          : getGroupedColumns().map((column) => column.name);
      if (transportOperatorSelected.type === 1) {
        headerSimplePdf.push('Operação');
      }

      let totalOrderValue = 0;
      let totalValue = 0;

      let rowsPaymentSimplePdf =
        initialCompanyReportList?.length > 0
          ? initialCompanyReportList?.map((item: any) => {
              let finalOrderValue = 0;
              finalOrderValue = item?.Taxes?.reduce(
                (acc: any, curr: any) => acc + curr.value,
                0,
              )
                ? item.value -
                  item?.Taxes?.reduce(
                    (acc: any, curr: any) => acc + curr.value,
                    0,
                  )
                : item.value;

              totalOrderValue += finalOrderValue;
              totalValue += item.value;

              return [
                item?.id ? item?.id?.split('-')?.[0] : '-',
                item?.name ? item?.name : '-',
                new Date(item?.createdAt).getTime()
                  ? new Date(item.createdAt).toLocaleString('pt-BR')
                  : '-',
                item?.document ? item?.document : item?.cnpj,
                item?.paymentMethod
                  ? CONST_TRANSPORT_VOUCHER_COLLECTION.PAYMENT_TYPE.find(
                      ({ KEY }) => KEY === item?.paymentMethod,
                    )?.VALUE
                  : '-',
                item?.value
                  ? item?.value?.toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                    })
                  : '-',
                item?.Taxes?.length > 0
                  ? item?.Taxes?.reduce(
                      (acc: any, curr: any) => acc + curr.value,
                      0,
                    )
                  : '-',
                finalOrderValue?.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                }),
                item?.status
                  ? CONST_TRANSPORT_VOUCHER_COLLECTION.STATUS.find(
                      ({ KEY }) => KEY === item?.status,
                    )?.VALUE
                  : '-',
              ];
            })
          : [];
      let totalRowsSimplePdf = [
        'Total',
        '',
        '',
        '',
        '',
        totalOrderValue
          ? totalOrderValue?.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })
          : '-',
        '',
        totalValue
          ? totalValue?.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })
          : '-',
        '',
      ];

      if (transactionGroupings.length > 0) {
        rowsPaymentSimplePdf =
          initialCompanyReportList.length > 0
            ? initialCompanyReportList
                ?.sort((a: any, b: any) => {
                  if (a?.usedDate === undefined && b?.usedDate === undefined) {
                    return 0;
                  }

                  if (a?.usedDate === undefined) {
                    return 1;
                  }

                  if (b?.usedDate === undefined) {
                    return -1;
                  }

                  const dateA = a?.usedDate
                    .split('/')
                    .reverse()
                    .join('');

                  const dateB = b?.usedDate
                    .split('/')
                    .reverse()
                    .join('');

                  return dateA.localeCompare(dateB);
                })
                ?.map((request: any) => {
                  let finalOrderValue = request?.value ?? 0;
                  const row = getGroupedColumns().map((col) => {
                    const taxValue = request?.tax;
                    const formatter = fieldFormatting.get(col.key);

                    if (col.key === 'status' && formatter) {
                      const status = formatter(request[col.key]);

                      return `${status || '--'}`;
                    }

                    if (col.key === 'tax' && formatter) {
                      const decimalTaxValue = (taxValue ?? 0) / 100;
                      const taxAmount = (request?.value ?? 0) * decimalTaxValue;
                      finalOrderValue -= taxAmount;

                      return `${
                        taxValue
                          ? ` R$${taxAmount?.toLocaleString('pt-BR', {
                              minimumFractionDigits: 2,
                            })} `
                          : '---'
                      }`;
                    }

                    if (col.key === 'orderValue') {
                      return `${
                        taxValue > 0
                          ? ` R$${finalOrderValue?.toLocaleString('pt-BR', {
                              minimumFractionDigits: 2,
                            })} `
                          : request?.[col.key]?.toLocaleString('pt-BR', {
                              minimumFractionDigits: 2,
                            })
                      }`;
                    }

                    return `${
                      formatter
                        ? formatter(request?.[col.key])
                        : request?.[col.key] || '--'
                    }`;
                  });
                  if (transportOperatorSelected.type === 1) {
                    row.push(
                      transportOperatorsList.find(
                        (e) => e.id === request?.transportOperatorId,
                      )?.name || '---',
                    );
                  }
                  return row;
                })
            : [];
        const groupedTotalValue = initialCompanyReportList.reduce(
          (acc, curr) => acc + (curr?.totalValue ?? 0),
          0,
        );
        const groupdTotalCount = initialCompanyReportList.reduce(
          (acc, curr) => acc + (curr?.count ?? 0),
          0,
        );
        totalRowsSimplePdf = getGroupedColumns().map((column, i) => {
          if (i === 0) return 'Total';
          if (column.key === TOTAL_VALUE.key) {
            return groupedTotalValue
              ? groupedTotalValue?.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              : '-';
          }
          if (column.key === COUNT.key) {
            return `${groupdTotalCount}`;
          }
          return '';
        });
      }
      if (transportOperatorSelected.type === 1) {
        totalRowsSimplePdf.push('');
      }

      const tempSimplePdfData = {
        title: 'ONBOARD',
        subtitle: 'Relatório de Vale Transporte',
        filters: periodString || '',
        headers: headerSimplePdf,
        rows: [...rowsPaymentSimplePdf, totalRowsSimplePdf],
      };

      setSimplePdfData(tempSimplePdfData);
    }
  }, [
    currNavGuide,
    initialCompanyReportList,
    headerTaxes,
    periodString,
    transportOperatorSelected,
    transportOperatorsList,
  ]);

  useEffect(() => {
    if (currNavGuide === 1) {
      const headerSimplePdf = [
        'ID',
        'Valor Pedido',
        ...headerTaxes,
        'Valor Pago',
      ];

      const rowsTaxesSimplePdf =
        initialCompanyReportList?.length > 0
          ? initialCompanyReportList
              ?.filter((item: any) => item?.Taxes?.length! > 0)
              .map((item: any) => {
                let finalOrderValue = item?.value ?? 0;
                return [
                  {
                    key: 'ID',
                    value: item?.id ? item?.id?.split('-')?.[0] : '-',
                    stringValue: item?.id ? item?.id?.split('-')?.[0] : '-',
                  },
                  {
                    key: 'Valor Pedido',
                    value: item?.value,
                    stringValue: item?.value
                      ? `R$${item?.value?.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                        })}`
                      : '-',
                  },
                  ...(headerTaxes?.length > 0
                    ? headerTaxes?.reduce((acc: any, tax: any) => {
                        const taxValue = item?.Taxes?.find(
                          (item: any) => item.name === tax,
                        )?.value;

                        const decimalTaxValue = (taxValue ?? 0) / 100;
                        const taxAmount = (item?.value ?? 0) * decimalTaxValue;
                        finalOrderValue -= taxAmount;

                        if (taxValue) {
                          acc.push({
                            key: tax,
                            value: taxAmount,
                            stringValue: ` R$${taxAmount?.toLocaleString(
                              'pt-BR',
                              {
                                minimumFractionDigits: 2,
                              },
                            )} `,
                          });
                        } else {
                          acc.push({ key: tax, value: 0, stringValue: '-' });
                        }

                        return acc;
                      }, [])
                    : []),
                  {
                    key: 'Valor Pago',
                    value: finalOrderValue,
                    stringValue: finalOrderValue
                      ? `R$${finalOrderValue?.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                        })}`
                      : '-',
                  },
                ];
              })
          : [];

      const totalRowsTaxesSimplePdf = rowsTaxesSimplePdf.reduce((acc, curr) => {
        acc[0] = 'Total';
        curr.forEach((item, i) => {
          if (item.key !== 'ID') {
            if (!acc[i]) {
              acc[i] = item.value;
            } else {
              acc[i] += item.value;
            }
          }
        });
        return acc;
      }, []);

      const tempSimplePdfData = {
        title: 'ONBOARD',
        subtitle: 'Relatório de Vale Transporte',
        filters: periodString || '',
        headers: headerSimplePdf,
        rows: [
          ...rowsTaxesSimplePdf.map((e) => e.map((s) => s.stringValue)),
          totalRowsTaxesSimplePdf.map((e) =>
            e === 'Total'
              ? e
              : `R$${e?.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })}`,
          ),
        ],
      };

      setSimplePdfData(tempSimplePdfData);
    }
  }, [currNavGuide, initialCompanyReportList, headerTaxes, periodString]);

  useEffect(() => {
    // fill xls state
    if (setXlsHeader) {
      setXlsHeader(
        simplePdfData.headers.map((s: XlsHeaderInterface) => ({
          header: s,
          key: s,
          width: 20,
        })),
      );
    }
    if (setXlsRows) {
      setXlsRows(
        simplePdfData.rows.map((arr: string[]) =>
          arr.map((s: string, i: number) => ({
            key: simplePdfData.headers[i],
            value: s,
            image: null,
          })),
        ) as XlsRowInterface[][],
      );
    }
  }, [simplePdfData]);

  return (
    <div className={classes.root}>
      <Dialog open={groupingsDialog} onClose={() => setGroupingsDialog(false)}>
        <GroupingsModal
          groupingOptions={transactionOptions}
          selectedOptions={transactionGroupings}
          handleGrouping={handleTransactionGrouping}
          setOpenModal={setGroupingsDialog}
        />
      </Dialog>
      <MainContent className={classes.paperRoot}>
        <Grid className={classes.gridContent} container spacing={2}>
          <Grid item xs={12} ref={(ref: any) => setTableReference(ref)}>
            <Grid container justifyContent='space-between'>
              <Grid item>
                <ReportTitle
                  titleVariant='h4'
                  title='Relatório de Arrecadação • Vale Transporte'
                  tooltipTitle={
                    TITLES_OPTIONS.REPORTS.COLLECTION.TRANSPORTATION_VOUCHERS
                      .VALUE
                  }
                />
              </Grid>
              {reportIsVisible && (
                <Grid item>
                  <CSVLink
                    filename='Relatório de Arrecadação-Vale-transporte.csv'
                    data={tableCSV}
                    ref={csvRef}>
                    <Tooltip title='Baixar CSV' placement='top'>
                      <IconButton />
                    </Tooltip>
                  </CSVLink>
                </Grid>
              )}
            </Grid>
            <Grid container spacing={1} alignItems='center'>
              <Grid item xs={12}>
                <Grid container spacing={1} justifyContent='flex-start'>
                  {/* <Grid item xs={12}>
                    <Grid container spacing={0}>
                      <Box
                        display='flex'
                        alignItems='center'
                        width='100%'
                        marginTop='8px'>

                        <Grid container justifyContent='flex-end'>
                          <Button
                            className={classes.addButton}
                            onClick={() => setIsAddSubmissiion(true)}>
                            <Typography
                              style={{ marginRight: 8, fontSize: 20 }}>
                              +
                            </Typography>{' '}
                            <Typography style={{ fontSize: 12 }}>
                              Programar Novo
                            </Typography>
                          </Button>
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid> */}
                  <Grid item xs={12}>
                    <Grid container spacing={0}>
                      <Box
                        display='flex'
                        width='100%'
                        mt={2}
                        ml={2}
                        maxWidth='580px'>
                        {' '}
                        <SearchComponent
                          currNavGuide={currNavGuide}
                          data={initialCompanyReportList}
                          itemsByFilter={ITEMS.ReportTransportVoucherCollection}
                          results={(data: any[]) => setTransactionsList(data)}
                          disabledInput={!reportIsVisible}
                          modalFilter={() => {
                            dispatch(
                              setOpen({
                                open: true,
                                content: (
                                  <Suspense fallback={<p>Carregando...</p>}>
                                    <Filter
                                      fields={
                                        ITEMS.transportVoucherCollection
                                          .transactionsTabRemote
                                      }
                                      handleApply={handleApply}
                                    />
                                  </Suspense>
                                ),
                                maxWidth: 'xl',
                              }),
                            );
                          }}
                        />
                        {reportIsVisible && currNavGuide === 0 && (
                          <Typography
                            component='span'
                            onClick={() => setGroupingsDialog(true)}>
                            <Box className={classes.contentGroupings}>
                              <Box className={classes.groupings}>
                                <img
                                  src={IMAGES.ICONS.GROUPINGS}
                                  alt='groupings'
                                />
                              </Box>
                              {!!transactionGroupings.length && (
                                <Box className={classes.badge}>
                                  {transactionGroupings.length}
                                </Box>
                              )}
                            </Box>
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Tabs
              indicatorColor='primary'
              onChange={handleChange}
              style={{
                background: '#ffffff',
                margin: '10px 0px 32px 0px',
              }}
              textColor='primary'
              value={generalNavGuide}>
              <Tab label='Relatório' />
              <Tab label='Envios' />
              <Tab label='Histórico' />
            </Tabs>

            <TabPanel index={0} value={generalNavGuide}>
              <Grid item xs={12}>
                {!reportIsVisible && (
                  <TablePlaceholder onClick={handleLoadData} />
                )}
                {/* Navigation Guide */}
                {reportIsVisible && (
                  <>
                    <Grid item>
                      <Grid
                        container
                        justifyContent='flex-end'
                        alignItems='center'>
                        <Box display='flex' alignItems='center'>
                          <Box pr='0.5rem'>
                            {' '}
                            <DialogueExport
                              tableInstance={tableReference}
                              csvRef={csvRef}
                              simplePdf
                              simplePdfData={simplePdfData}
                              columnsPerPage={5}
                              totalRows
                              pdfName={
                                currNavGuide === 0
                                  ? 'relatorio_arrecadacao_vale_transporte_pedidos'
                                  : 'relatorio_arrecadacao_vale_transporte_impostos'
                              }
                              xlsTitle={
                                currNavGuide === 0
                                  ? 'relatorio_arrecadacao_vale_transporte_pedidos'
                                  : 'relatorio_arrecadacao_vale_transporte_impostos'
                              }
                              xlsHeader={xlsHeader}
                              xlsRows={xlsRows}
                              pdf
                              csv
                              xls
                            />
                          </Box>
                          {!transactionGroupings.length ||
                          transactionGroupings.includes('status') ? (
                            <Box className={classes.resume}>
                              <Box className={classes.contentImage}>
                                <img
                                  src={IMAGES.REPORTS_ICONS.TOTAL_ENTRY}
                                  alt='total entry'
                                />
                              </Box>
                              <Divider
                                className={classes.dividerVertical}
                                orientation='vertical'
                                flexItem
                              />
                              <Grid className={classes.contentTotalEntry}>
                                <Typography className={classes.subTiltle}>
                                  Erros
                                </Typography>
                                <Typography className={classes.value}>
                                  {`${totalError?.toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                  })}`}
                                </Typography>
                              </Grid>
                              <Divider
                                className={classes.dividerVertical}
                                orientation='vertical'
                                flexItem
                              />
                              <Grid className={classes.contentTotalEntry}>
                                <Typography className={classes.subTiltle}>
                                  Completado
                                </Typography>
                                <Typography className={classes.value}>
                                  {`${totalPaid?.toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                  })}`}
                                </Typography>
                              </Grid>
                              <Divider
                                className={classes.dividerVertical}
                                orientation='vertical'
                                flexItem
                              />{' '}
                              <Grid className={classes.contentTotalEntry}>
                                <Typography className={classes.subTiltle}>
                                  Pendente
                                </Typography>
                                <Typography className={classes.value}>
                                  {`${totalCollected?.toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                  })}`}
                                </Typography>
                              </Grid>
                              <Divider
                                className={classes.dividerVertical}
                                orientation='vertical'
                                flexItem
                              />
                              <Grid className={classes.contentTotalEntry}>
                                <Typography className={classes.subTiltle}>
                                  Outros
                                </Typography>
                                <Typography className={classes.value}>
                                  {`${totalOthers?.toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                  })}`}
                                </Typography>
                              </Grid>
                              <Divider
                                className={classes.dividerVertical}
                                orientation='vertical'
                                flexItem
                              />{' '}
                              <Grid className={classes.contentTotalEntry}>
                                <Typography className={classes.subTiltle}>
                                  Total
                                </Typography>
                                <Typography className={classes.value}>
                                  {`${total?.toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                  })}`}
                                </Typography>
                              </Grid>
                            </Box>
                          ) : (
                            <Box className={classes.resume}>
                              <Box className={classes.contentImage}>
                                <img
                                  src={IMAGES.REPORTS_ICONS.TOTAL_ENTRY}
                                  alt='total entry'
                                />
                              </Box>
                              <Divider
                                className={classes.dividerVertical}
                                orientation='vertical'
                                flexItem
                              />{' '}
                              <Grid className={classes.contentTotalEntry}>
                                <Typography className={classes.subTiltle}>
                                  Total
                                </Typography>
                                <Typography className={classes.value}>
                                  {`${totalPaidWithDates?.toLocaleString(
                                    'pt-BR',
                                    {
                                      minimumFractionDigits: 2,
                                    },
                                  )}`}
                                </Typography>
                              </Grid>
                            </Box>
                          )}
                        </Box>
                      </Grid>
                      {!transactionGroupings.length && (
                        <>
                          <Grid
                            container
                            justifyContent='flex-end'
                            alignItems='center'>
                            <Box
                              display='flex'
                              alignItems='center'
                              pt='0.75rem'>
                              <Box className={classes.resume}>
                                <Box className={classes.contentImage}>
                                  <img
                                    src={IMAGES.REPORTS_ICONS.TOTAL_ENTRY}
                                    alt='total entry'
                                  />
                                </Box>
                                <Divider
                                  className={classes.dividerVertical}
                                  orientation='vertical'
                                  flexItem
                                />
                                <Grid className={classes.contentTotalEntry}>
                                  <Typography className={classes.subTiltle}>
                                    PIX
                                  </Typography>
                                  <Typography className={classes.value}>
                                    {`${totalPix?.toLocaleString('pt-BR', {
                                      minimumFractionDigits: 2,
                                    })}`}
                                  </Typography>
                                </Grid>
                                <Divider
                                  className={classes.dividerVertical}
                                  orientation='vertical'
                                  flexItem
                                />
                                <Grid className={classes.contentTotalEntry}>
                                  <Typography className={classes.subTiltle}>
                                    CRÉDITO
                                  </Typography>
                                  <Typography className={classes.value}>
                                    {`${totalCreditCard?.toLocaleString(
                                      'pt-BR',
                                      {
                                        minimumFractionDigits: 2,
                                      },
                                    )}`}
                                  </Typography>
                                </Grid>
                                <Divider
                                  className={classes.dividerVertical}
                                  orientation='vertical'
                                  flexItem
                                />
                                <Grid className={classes.contentTotalEntry}>
                                  <Typography className={classes.subTiltle}>
                                    DÉBITO
                                  </Typography>
                                  <Typography className={classes.value}>
                                    {`${totalDebitCard?.toLocaleString(
                                      'pt-BR',
                                      {
                                        minimumFractionDigits: 2,
                                      },
                                    )}`}
                                  </Typography>
                                </Grid>
                                <Divider
                                  className={classes.dividerVertical}
                                  orientation='vertical'
                                  flexItem
                                />
                                <Grid className={classes.contentTotalEntry}>
                                  <Typography className={classes.subTiltle}>
                                    BOLETO
                                  </Typography>
                                  <Typography className={classes.value}>
                                    {`${totalBoleto?.toLocaleString('pt-BR', {
                                      minimumFractionDigits: 2,
                                    })}`}
                                  </Typography>
                                </Grid>
                                <Divider
                                  className={classes.dividerVertical}
                                  orientation='vertical'
                                  flexItem
                                />
                                <Grid className={classes.contentTotalEntry}>
                                  <Typography className={classes.subTiltle}>
                                    DINHEIRO
                                  </Typography>
                                  <Typography className={classes.value}>
                                    {`${totalMoney?.toLocaleString('pt-BR', {
                                      minimumFractionDigits: 2,
                                    })}`}
                                  </Typography>
                                </Grid>
                                <Divider
                                  className={classes.dividerVertical}
                                  orientation='vertical'
                                  flexItem
                                />
                                <Grid className={classes.contentTotalEntry}>
                                  <Typography className={classes.subTiltle}>
                                    GRATUIDADE
                                  </Typography>
                                  <Typography className={classes.value}>
                                    {`${totalFree?.toLocaleString('pt-BR', {
                                      minimumFractionDigits: 2,
                                    })}`}
                                  </Typography>
                                </Grid>
                                <Divider
                                  className={classes.dividerVertical}
                                  orientation='vertical'
                                  flexItem
                                />{' '}
                                <Grid className={classes.contentTotalEntry}>
                                  <Typography className={classes.subTiltle}>
                                    Total
                                  </Typography>
                                  <Typography className={classes.value}>
                                    {`${(
                                      totalPix +
                                      totalCreditCard +
                                      totalDebitCard +
                                      totalBoleto +
                                      totalMoney +
                                      totalFree
                                    )?.toLocaleString('pt-BR', {
                                      minimumFractionDigits: 2,
                                    })}`}
                                  </Typography>
                                </Grid>
                              </Box>
                            </Box>
                          </Grid>
                          <Grid
                            container
                            justifyContent='flex-end'
                            alignItems='center'>
                            <Box
                              display='flex'
                              alignItems='center'
                              pt='0.75rem'>
                              <Box className={classes.resume}>
                                <Box className={classes.contentImage}>
                                  <img
                                    src={IMAGES.REPORTS_ICONS.TOTAL_ENTRY}
                                    alt='total entry'
                                  />
                                </Box>
                                <Divider
                                  className={classes.dividerVertical}
                                  orientation='vertical'
                                  flexItem
                                />
                                <Grid className={classes.contentTotalEntry}>
                                  <Typography className={classes.subTiltle}>
                                    VOUCHER
                                  </Typography>
                                  <Typography className={classes.value}>
                                    {`${totalVoucher?.toLocaleString('pt-BR', {
                                      minimumFractionDigits: 2,
                                    })}`}
                                  </Typography>
                                </Grid>
                                <Divider
                                  className={classes.dividerVertical}
                                  orientation='vertical'
                                  flexItem
                                />
                                <Grid className={classes.contentTotalEntry}>
                                  <Typography className={classes.subTiltle}>
                                    REQUISIÇÂO
                                  </Typography>
                                  <Typography className={classes.value}>
                                    {`${totalRequisition?.toLocaleString(
                                      'pt-BR',
                                      {
                                        minimumFractionDigits: 2,
                                      },
                                    )}`}
                                  </Typography>
                                </Grid>
                                <Divider
                                  className={classes.dividerVertical}
                                  orientation='vertical'
                                  flexItem
                                />
                                <Grid className={classes.contentTotalEntry}>
                                  <Typography className={classes.subTiltle}>
                                    PÓS PAGO
                                  </Typography>
                                  <Typography className={classes.value}>
                                    {`${totalPosPaid?.toLocaleString('pt-BR', {
                                      minimumFractionDigits: 2,
                                    })}`}
                                  </Typography>
                                </Grid>
                                <Divider
                                  className={classes.dividerVertical}
                                  orientation='vertical'
                                  flexItem
                                />
                                <Grid className={classes.contentTotalEntry}>
                                  <Typography className={classes.subTiltle}>
                                    PAGAMENTO EXTERNO
                                  </Typography>
                                  <Typography className={classes.value}>
                                    {`${totalExternal?.toLocaleString('pt-BR', {
                                      minimumFractionDigits: 2,
                                    })}`}
                                  </Typography>
                                </Grid>
                                <Divider
                                  className={classes.dividerVertical}
                                  orientation='vertical'
                                  flexItem
                                />{' '}
                                <Grid className={classes.contentTotalEntry}>
                                  <Typography className={classes.subTiltle}>
                                    Total
                                  </Typography>
                                  <Typography className={classes.value}>
                                    {`${(
                                      totalVoucher +
                                      totalRequisition +
                                      totalPosPaid +
                                      totalExternal
                                    )?.toLocaleString('pt-BR', {
                                      minimumFractionDigits: 2,
                                    })}`}
                                  </Typography>
                                </Grid>
                              </Box>
                            </Box>
                          </Grid>
                        </>
                      )}
                    </Grid>

                    {initialCompanyReportList?.length! > 0 && (
                      <Box
                        width='100%'
                        display='flex'
                        justifyContent='flex-end'>
                        <Suspense fallback='Carregando...'>
                          <TotalCountComponent
                            count={
                              currNavGuide === 0
                                ? initialCompanyReportList?.length! || 0
                                : initialCompanyReportList
                                    ?.map((order) => {
                                      if (order?.Taxes?.length! > 0) {
                                        return order;
                                      }

                                      return null;
                                    })
                                    .filter(Boolean)?.length! || 0
                            }
                            title={currNavGuide === 0 ? 'pedidos' : 'impostos'}
                            position='right'
                          />
                        </Suspense>
                      </Box>
                    )}

                    <CustomTabs
                      setCurrNavGuide={setCurrNavGuide}
                      currNavGuide={currNavGuide}
                      labels={['Pedidos', 'Impostos']}
                    />
                    <SwipeableViews
                      axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                      index={currNavGuide}>
                      {/* Transações */}
                      <TabPanel index={0} value={currNavGuide}>
                        <TransactionNavigation
                          groupings={transactionGroupings}
                          setTableCSV={setTableCSV}
                          setTableReference={setTableReference}
                          transactionslist={transactionslist}
                          groupedColumns={getGroupedColumns}
                          fieldFormatting={fieldFormatting}
                        />
                      </TabPanel>
                      <TabPanel index={1} value={currNavGuide}>
                        <TaxesNavigation
                          headerTaxes={
                            headerTaxes?.length > 0 ? headerTaxes : []
                          }
                          setTableReference={setTableReference}
                        />
                      </TabPanel>
                    </SwipeableViews>
                  </>
                )}
              </Grid>
            </TabPanel>
            <TabPanel index={1} value={generalNavGuide}>
              <Submissions
                setSubmissionData={setSubmissionData}
                setIsEditSubmissiion={setIsEditSubmissiion}
                reportType={REPORTS_TYPES.CHARGE_GENERAL}
              />
            </TabPanel>
            <TabPanel index={2} value={generalNavGuide}>
              <History reportType={REPORTS_TYPES.CHARGE_GENERAL} />
            </TabPanel>
          </Grid>
        </Grid>
      </MainContent>
    </div>
  );
};

export { TransportVoucherCollectionReportDatails };
export default TransportVoucherCollectionReportDatails;
